

import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
export default {
    title : {
        x:'center'
    },
    tooltip : {
        trigger: 'item',
        formatter: "{a} <br/>{b} : {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',
        left: 'left',
        data: [getLabel(387994,"直接访问"),getLabel(387995,"邮件营销"),getLabel(387996,"联盟广告")]
    },
    series : [
        {
            name: getLabel(387997,"访问来源"),
            type: 'pie',
            radius : '55%',
            center: ['50%', '60%'],
            data:[
                {value:335, name:getLabel(387994,"直接访问")},
                {value:310, name:getLabel(387995,"邮件营销")},
                {value:234, name:getLabel(387996,"联盟广告")}
            ],
            itemStyle: {
                emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/echart/examples/pie3d.js